<template>
  <svg
    class="mypage-ticket-accordion-icon-parts"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.72394 5.17313L7.05727 10.5065C7.57797 11.0272 8.42219 11.0272 8.94289 10.5065L14.2762 5.17313L12.3906 5.17313L8.00008 9.56365L3.60956 5.17313H1.72394Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MypageTicketAccordionIconParts',
})
</script>

<style scoped lang="scss">
.mypage-ticket-accordion-icon-parts {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
